var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("check-box-list-row", {
        key: _vm.checkBoxValuesChanged,
        attrs: {
          title: _vm.pathKey + ".Premises.PremiseTypes.Title",
          options: _vm.premisesOptions
        },
        model: {
          value: _vm.premises.premiseTypes,
          callback: function($$v) {
            _vm.$set(_vm.premises, "premiseTypes", $$v)
          },
          expression: "premises.premiseTypes"
        }
      }),
      _vm._v(" "),
      _vm.showOwnPremises
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("plain-text-control", {
                attrs: {
                  title: _vm.pathKey + ".Premises.OwnPremises.Title",
                  required: true
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.ownPremises, function(premise, index) {
                return _vm.ownPremises
                  ? _c(
                      "div",
                      { key: index },
                      [
                        _c("div", { staticClass: "row form-group mt-3" }, [
                          _c(
                            "div",
                            {
                              class:
                                "col-8 d-flex flex-column justify-content-end own-premise-" +
                                (index + 1)
                            },
                            [
                              _c("plain-text-control", {
                                staticClass: "bold",
                                attrs: {
                                  id: "ownpremises_" + index,
                                  title: _vm.getOwnPremisesTableTitle(index),
                                  doNotUseResources: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _vm.showOwnPremisesDeleteBtn() && !_vm.isReadOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link btn-contrast float-right",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        _vm.$t("Btn_DeletePremisesTable") +
                                        " " +
                                        _vm.$t(
                                          "Accessibility.ConfirmDeleteTable"
                                        )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteOwnPremisesTable(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash-alt fa-lg",
                                      attrs: {
                                        title: _vm.$t("Btn_DeletePremisesTable")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("premises-table-control", {
                          attrs: {
                            premise: premise,
                            columnTitles: _vm.ownPremisesColumns,
                            required: true,
                            ownPremises: true,
                            labelledBy: "ownpremises_" + index,
                            rowHeaderKey: _vm.premiseRowHeaderKey
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 mb-5" }, [
                !_vm.isReadOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isOwnPremisesBtnDisabled,
                          "aria-disabled": _vm.isOwnPremisesBtnDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.addOwnPremise(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AidApplication.Btn_AddOwnPremise"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRelatedPremises
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("plain-text-control", {
                attrs: {
                  title: _vm.pathKey + ".Premises.RelatedPremises.Title",
                  required: true
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.relatedPremises, function(premise, index) {
                return _vm.relatedPremises
                  ? _c(
                      "div",
                      { key: index },
                      [
                        _c("div", { staticClass: "row form-group mt-3" }, [
                          _c(
                            "div",
                            {
                              class:
                                "col-8 d-flex flex-column justify-content-end related-premise-" +
                                (index + 1)
                            },
                            [
                              _c("plain-text-control", {
                                staticClass: "bold",
                                attrs: {
                                  id: "relatedpremises_" + index,
                                  title: _vm.getRelatedPremisesTableTitle(
                                    index
                                  ),
                                  doNotUseResources: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _vm.showRelatedPremisesDeleteBtn() &&
                            !_vm.isReadOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link btn-contrast float-right",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        _vm.$t("Btn_DeletePremisesTable") +
                                        " " +
                                        _vm.$t(
                                          "Accessibility.ConfirmDeleteTable"
                                        )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteRelatedPremisesTable(
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash-alt fa-lg",
                                      attrs: {
                                        title: _vm.$t("Btn_DeletePremisesTable")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("premises-table-control", {
                          attrs: {
                            premise: premise,
                            columnTitles: _vm.relatedPremisesColumns,
                            required: true,
                            labelledBy: "relatedpremises_" + index,
                            rowHeaderKey: _vm.premiseRowHeaderKey
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 mb-5" }, [
                !_vm.isReadOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isRelatedPremisesBtnDisabled,
                          "aria-disabled": _vm.isRelatedPremisesBtnDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.addRelatedPremise(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AidApplication.Btn_AddRelatedPremise"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRentalPremises
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("plain-text-control", {
                attrs: {
                  title: _vm.pathKey + ".Premises.RentalPremises.Title",
                  required: true
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.rentalPremises, function(premise, index) {
                return _vm.rentalPremises
                  ? _c(
                      "div",
                      { key: index },
                      [
                        _c("div", { staticClass: "row form-group mt-3" }, [
                          _c(
                            "div",
                            {
                              class:
                                "col-8 d-flex flex-column justify-content-end rental-premise-" +
                                (index + 1)
                            },
                            [
                              _c("plain-text-control", {
                                staticClass: "bold",
                                attrs: {
                                  id: "rentalpremises_" + index,
                                  title: _vm.getRentalPremisesTableTitle(index),
                                  doNotUseResources: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _vm.showRentalPremisesDeleteBtn() && !_vm.isReadOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-contrast btn-link float-right",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        _vm.$t("Btn_DeletePremisesTable") +
                                        " " +
                                        _vm.$t(
                                          "Accessibility.ConfirmDeleteTable"
                                        )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteRentalPremisesTable(
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash-alt fa-lg",
                                      attrs: {
                                        title: _vm.$t("Btn_DeletePremisesTable")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("premises-table-control", {
                          attrs: {
                            premise: premise,
                            columnTitles: _vm.rentalPremisesColumns,
                            required: true,
                            options: _vm.ownerOptions,
                            labelledBy: "rentalpremises_" + index,
                            rowHeaderKey: _vm.premiseRowHeaderKey
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 mb-5" }, [
                !_vm.isReadOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isRentalPremisesBtnDisabled,
                          "aria-disabled": _vm.isRentalPremisesBtnDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.addRentalPremise(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AidApplication.Btn_AddRentalPremise"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showOtherPremises
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("text-area-row", {
                attrs: {
                  title: _vm.pathKey + ".Premises.OtherPremises",
                  id: "otherpremises",
                  required: true,
                  maxLength: 1000,
                  rows: 10
                },
                model: {
                  value: _vm.premises.otherPremises,
                  callback: function($$v) {
                    _vm.$set(_vm.premises, "otherPremises", $$v)
                  },
                  expression: "premises.otherPremises"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }